import React, { useEffect, useState, useRef } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SolutionSection = () => {
    return (
        <>
        <Box
            sx={{
                backgroundColor: '#20defa',
                color: 'white',
                textAlign: 'center',
                position: 'relative',
                paddingTop: { xs: 2, xxl: 6},
                paddingBottom: { xs: 2, xxl: 6},
                px: 1
            }}
        >
            <Box
                sx={{
                    width: { xs: "100%", xxl: "70%" },
                    margin: "0 auto"
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        lineHeight: 1.5,
                        fontSize: { xs: "20px", xxl: "36px" },
                        color: '#002077',
                    }}
                >
                    Ce poți schimba prin Academillion?
                </Typography>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#000',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        mt: { xs: 3, xxl: 4 },
                        alignItems: 'center',
                    }}
                >
                    {[
                        "Înveți să identifici oportunități reale cu o metodologie clară, aplicată de investitori activi. Nu mai iei decizii bazate pe instinct, zvonuri sau frica de a pierde „trenul” – și nu mai investești emoțional.",
                        "Prin coaching personalizat, îți clarifici obiectivele și înveți să aplici o strategie adaptată 100% situației și portofoliului tău.",
                        "Nu mai faci greșelile singur – le eviți împreună cu o comunitate care știe drumul, îți oferă sprijin și validare.",
                        "Ai parte de o comunitate căreia nu îi este frică să vorbească despre bani sau provocările pe care le au. Sunt oameni care au trecut prin aceleași experiențe ca tine și oferă sprijin real.",
                        "Primești informații validate de experți, cu due diligence riguros. Nu te mai lași păcălit de aparențe sau promisiuni nerealiste, ci ai confirmarea că sunt cu adevărat oportunități.",
                        "Accesezi cursuri structurate, înveți în ritmul tău și poți adresa întrebări direct în sesiuni live experților care le-au realizat.",
                        "Ai parte de sesiuni 1:1, mastermind-uri comunitare și întâlniri de networking unde poți veni cu problemele tale și să obții răspunsuri punctuale, direct de la investitori și experți în domeniu.",
                        "Mindset-ul potrivit nu-l deprinzi doar din cărți, îl cultivi cu oamenii care își doresc același lucru ca tine sau trăiesc deja stilul de viață la care tu aspiri.",
                        "Ai acces la oportunități de investiții negociate în condiții avantajoase, împreună cu suport pentru analiză. Tu iei decizia finală, dar o faci informat.",
                    ].map((text, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <CheckCircleOutlineIcon sx={{ color: "#002077", fontSize: "42px", mr: 1 }} />
                        <Typography
                            variant="subtitle2"
                            sx={{
                            color: '#000',
                            fontWeight: 500,
                            fontSize: { xs: "14px", xxl: "21px" },
                            lineHeight: "28px",
                            letterSpacing: "normal",
                            }}
                        >
                            {text}
                        </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
        </>
    );
};

export default SolutionSection;